// Framework
import { Component, OnInit } from '@angular/core'

@Component({
  templateUrl: './view2.component.html',
  styleUrls: ['./view2.component.scss'],
})
export class LayoutSidebarView2Component implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
